module.exports = __webpack_public_path__ + "img/skinxs-icon.f2b29a06.svg";